import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import AuthModule from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import ErrorModule from "@/store/modules/ErrorModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";
import DynamicListModule from "@/store/modules/DynamicListModule";
import DynamicFormModule from "@/store/modules/DynamicFormModule";
import DynamicFilterModule from "@/store/modules/DynamicFilterModule";

import PaginationModule from "@/store/modules/PaginationModule";

import CatalogueModule from "@/store/modules/CatalogueModule";

import ChartsModule from "@/store/modules/ChartsModule";
import MenuModule from "@/store/modules/MenuModule";

config.rawError = true;

const store = createStore({
  modules: {
    AuthModule:AuthModule,
    ErrorModule:ErrorModule,
    BodyModule:BodyModule,
    BreadcrumbsModule:BreadcrumbsModule,
    ConfigModule:ConfigModule,
    DynamicListModule:DynamicListModule,
    DynamicFormModule:DynamicFormModule,
    PaginationModule:PaginationModule,
    DynamicFilterModule:DynamicFilterModule,
    CatalogueModule:CatalogueModule,
    ChartsModule:ChartsModule,
    MenuModule:MenuModule
  },
});

export default store;
